import React, { FC } from 'react';
import boatImg from './boat.png';
import './HorizontalLine.scss';

const HorizontalLine: FC = () => (
  <div className="horizontal-line">
    <img src={boatImg} alt="boat" className="horizontal-line__img" />
  </div>
);
export default HorizontalLine;
